import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { theme } from '@features/executive-report/domain/theme';
import { Table, TableRow } from '@features/powerpoint';
import {
  INDEX_WIDTH,
  NORMAL_WIDTH,
  ROWS_PER_TABLE,
  headersToTableRow,
  defaultTableOptions,
  cellOptionsByIndex,
  VISIT_INDEX_WIDTH,
} from './table-utils';
import { sortBy } from '@utils/arrays';
import { MetaTableStyle } from '@features/executive-report/domain/meta-table-style';

const headers = ['', 'DMA', 'Visit Index'].map(header => header.toUpperCase());

export const dmasTable = (
  dmaVisits: CampaignAnalyticsReport['dmaVisits'],
  metaTableStyle?: MetaTableStyle
): Table => {
  const topDmasRows: TableRow[] = dmaVisits.data
    .toSorted(sortBy('visitIndex', 'desc'))
    .slice(0, ROWS_PER_TABLE)
    .map((dmaVisit, index): TableRow => {
      const options = cellOptionsByIndex(
        index,
        Math.min(dmaVisits.data.length, ROWS_PER_TABLE),
        metaTableStyle
      );

      return [
        {
          text: (index + 1).toString(),
          options: {
            ...options,
            color: metaTableStyle?.cellFontColor ?? theme.colors.lightBlue,
            align: 'center',
          },
        },
        {
          text: dmaVisit.location,
          options: {
            ...options,
            bold: true,
          },
        },
        {
          text: dmaVisit.visitIndex.toString(),
          options: {
            ...options,
            align: 'center',
          },
        },
      ];
    });

  return {
    tableRows: [
      headersToTableRow(headers, undefined, metaTableStyle),
      ...topDmasRows,
    ],
    options: {
      ...defaultTableOptions,
      color: metaTableStyle?.cellFontColor ?? defaultTableOptions.color,
      x: 3.71,
      colW: [INDEX_WIDTH, NORMAL_WIDTH, VISIT_INDEX_WIDTH],
    },
  };
};
